'use client';

import BasePageContainer from '@fdc/components/layout/base-page-container/base-page-container';
import { IframeContainer } from '@fdc/components/ui';
import { getTraderUrl } from '@fdc/utils/iframe.utils';
import { usePathname, useSearchParams } from 'next/navigation';
import { useCallback, useState } from 'react';

const STORE_FINDER_EXTRA_HEIGHT = 500;

export default function Index() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [traderRoute, setTraderRoute] = useState(() => {
    const search = searchParams.toString();
    return search ? `${pathname}?${search}` : pathname;
  });

  const iframeSrc = getTraderUrl(traderRoute);

  const handleRouteChange = useCallback((url: string) => {
    const parsed = new URL(url, window.location.origin);
    parsed.searchParams.delete('__embeddedInIframe');
    const cleanUrl = parsed.pathname + parsed.search;
    setTraderRoute(cleanUrl);
    window.history.pushState(null, '', cleanUrl);
  }, []);

  return (
    <BasePageContainer>
      <IframeContainer
        src={iframeSrc}
        onRouteChange={handleRouteChange}
        iframeProps={{ scrolling: 'no', allow: 'geolocation' }}
        extraHeight={STORE_FINDER_EXTRA_HEIGHT}
      />
    </BasePageContainer>
  );
}
